export default __webpack_public_path__ + "static/media/HybridSatellite.e39c0b61.png";